import React from 'react';

/* <p><a href={"https://kafka.apache.org/"} target="_blank">Apache, Apache Kafka, Kafka</a> and associated open source project names are trademrks of the <a href={"https://kafka.apache.org/"} target="_blank">Apache Software Foundation</a>. All other marks or logos used are the property of their respective owners.</p> */

/* component styles */
import { styles } from './styles.scss';

export const Footer = () =>
    <footer className={`${styles}`}>
        <div className="container">
            <div className="row">
                <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    <p>Copyright © 2016-2019 <a href="https://lenses.io"><u>Lenses.io</u></a> Ltd.</p>
                </div>
                <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    <p>Visit the <a href="https://lenses.io/welcome/"><u>Welcome Area</u></a></p>
                </div>
            </div>
        </div>
    </footer>;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js